export const SEO_CONFIG = {
    siteName: 'Nexly',
    siteUrl: 'https://nexly.tech',
    defaultTitle: 'Nexly - Automated Financial Statement Review Software',
    defaultDescription: 'Nexly automates financial statement review for auditors, financial reporters, and accountants. Reduce manual review tasks by 90% with AI-powered validation and analysis.',
    keywords: 'financial statement review, audit automation, financial reporting, compliance software, auditing tools, accounting automation, financial analysis, statement validation',
    ogImage: 'https://nexly.tech/logo_full.png',
}

export const STRUCTURED_DATA_CONFIG = {
    organization: {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Nexly',
        url: 'https://nexly.tech',
        logo: 'https://nexly.tech/logo_full.png',
        description: 'Automated financial statement review software for auditors and accountants',
        contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'Customer Service',
            url: 'https://nexly.tech/contacts',
        },
    },
    softwareApplication: {
        '@context': 'https://schema.org',
        '@type': 'SoftwareApplication',
        name: 'Nexly',
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web',
        offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'USD',
        },
        description: 'Automated financial statement review software for auditors, financial reporters, and accountants. Reduce manual review tasks by 90% with AI-powered validation.',
        featureList: [
            'Mathematical Accuracy',
            'Internal Consistency',
            'AI-powered validation',
            'Automated quality assurance',
            'Financial reporting compliance',
        ],
    },
}
